import Echo from "laravel-echo";
import Pusher from "pusher-js";

/**
 * Laravel Echo over the Pusher protocol (Soketi today; a future Reverb swap is
 * an .env change — same client). Client-only. If no broadcaster key is
 * configured the plugin injects `null` and the board falls back to polling
 * (mixins/boardSync.js), so an un-provisioned socket layer degrades gracefully
 * rather than breaking the board.
 */
export default function (ctx, inject) {
  if (process.server) {
    inject("echo", null);
    return;
  }

  const cfg = ctx.$config || {};
  const key = process.env.PUSHER_APP_KEY || cfg.pusherKey;

  if (!key) {
    inject("echo", null);
    return;
  }

  window.Pusher = Pusher;

  // The kiosk authenticates the private board channel with its stored token;
  // interactive users authenticate via the session cookie.
  let authToken = null;
  try {
    authToken = localStorage.getItem("boardToken");
  } catch (e) {
    authToken = null;
  }

  const echo = new Echo({
    broadcaster: "pusher",
    key,
    wsHost: process.env.PUSHER_HOST || cfg.pusherHost || window.location.hostname,
    wsPort: Number(process.env.PUSHER_PORT || cfg.pusherPort || 6001),
    wssPort: Number(process.env.PUSHER_PORT || cfg.pusherPort || 6001),
    forceTLS: (process.env.PUSHER_SCHEME || cfg.pusherScheme || "https") === "https",
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    cluster: process.env.PUSHER_APP_CLUSTER || "mt1",
    authEndpoint: (process.env.API_URL || cfg.apiURL || "") + "/broadcasting/auth",
    auth: {
      headers: authToken ? { Authorization: "Bearer " + authToken } : {},
    },
  });

  inject("echo", echo);
}
